export default [
  {
    title: 'Sobre a Provu',
    text: `A Provu surgiu em 2015 e desde então já emprestou mais de R$ 900 milhões para mais de 140 mil brasileiros! Especializada em crédito pessoal e crediário digital, a empresa oferece taxas mais justas e personalizadas devido à forte base tecnológica e a um time comprometido em revolucionar o acesso ao crédito.`,
  },
  {
    title: 'O que é empréstimo sem garantia?',
    text: `
      A principal característica do empréstimo pessoal sem garantia é não exigir que você coloque seus bens (ou seu salário) no contrato de aquisição como forma de assegurar o pagamento.
      Caso você fique inadimplente, a instituição financeira tomará as medidas cabíveis, como negativação do CPF e tentativas de renegociação.
      <br />
      Mas, como o empréstimo não tem garantia, as taxas geralmente são mais altas em relação ao empréstimo com garantia (quando você inclui seus bens para assegurar o pagamento).
      De maneira geral, ainda apresenta taxas de juros mais baixas e prazos maiores de pagamento em relação a outras modalidades de crédito, como cartão de crédito e cheque especial, por exemplo.
    `,
  },
  {
    title: 'Quais são as etapas de solicitação da oferta pré-aprovada?',
    text: `É super simples!
      <br />
      <ol>
        <li>
          Após clicar em “Solicitar oferta”    
        </li>
        <li>
          Clique em “continuar”. 
        </li>
        <li>
          Depois disso, você será direcionado (a) para o site da Provu para dar continuidade.
        </li>
      </ol>
      É só preencher todos os dados e seguir o que se pede.
    `,
  },
  {
    title: 'Para quando é a primeira parcela? ',
    text: `A primeira parcela do seu empréstimo com a Provu é gerada automaticamente pelo sistema da parceira. Ao informar a data de pagamento do seu salário, é escolhida uma data próxima para o vencimento da sua fatura. Essa informação é passada antes da assinatura do contrato.`,
  },
  {
    title: 'Posso alterar a taxa de juros?',
    text: `Não, na Provu as taxas de juros variam entre 5,4% a 11% ao mês e são estipuladas de acordo com o perfil financeiro de cada cliente.`,
  },
  {
    title:
      'Qual o limite de crédito disponível? Em quantas parcelas posso pagar?',
    text: `
      O valor mínimo para empréstimo é de R$ 2.500,00 (dois mil e quinhentos reais) e o valor máximo é R$ 50.000,00 (cinquenta mil reais), sendo o limite disponível definido no processo de análise de crédito. O empréstimo pessoal pode ser pago em até 36 parcelas. Cada oferta é gerada de acordo com perfil financeiro do cliente.
    `,
  },
  {
    title: 'Faz empréstimo para negativado?',
    text: `No momento, a Provu não faz empréstimo para pessoas com o CPF negativado.`,
  },
  {
    title: 'Por que devo conectar minha conta bancária ao site da Provu?',
    text: `Essa não é uma obrigatoriedade para quem busca empréstimo. Contudo, saiba que a principal vantagem de conectar a sua conta bancária é a rapidez na aprovação do empréstimo. Ao conectar a conta, o cliente também consegue uma taxa de juros personalizada. Isso acontece porque a instituição financeira acompanha a situação do cliente e identifica sua capacidade de pagamento.`,
  },
  {
    title: 'Quais documentos são necessários para fazer o empréstimo?',
    text: `
      Para fazer o pedido de empréstimo pessoal da Provu, é necessário enviar:
      <ul>
        <li>Documentos pessoais, como CNH ou RG</li>
        <li>Selfie segurando esse documento de identificação;</li>
        <li>Comprovante de renda: isso irá depender da sua ocupação, mas podem ser solicitados holerites, extrato bancário, declaração de Imposto de Renda ou algum documento complementar.</li>
        <li>Cédula de Crédito Bancário (CCB): contrato formal. É o contrato que vamos gerar para você assinar. Todo o processo é digital.</li>
      </ul>
    `,
  },
  {
    title: 'Quais as formas de pagamento?',
    text: `O pagamento é feito por meio do boleto bancário. Todo mês, o boleto é gerado e enviado antes do vencimento para seu e-mail, Whatsapp e SMS cadastrados.`,
  },
]
